var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar',{attrs:{"drawer":_vm.drawer,"mobile":_vm.mobile}}),_c('v-main',[_c('router-view')],1),_c('footer-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }